import { ExpressionOfflineDataFetcher } from '@skinsoft/data-store';
import { EntityDataStore } from '@skinsoft/entity-data-store';
import { API_ENDPOINTS } from '../..';

export interface Expression {
    id: string;
    type: string;
}

declare var EXPRESSION_SEARCH_TYPES: string[];

export class ExpressionDataStore extends EntityDataStore<Expression> {
    public static getInstance() {
        if (!ExpressionDataStore.instance) {
            ExpressionDataStore.instance = new ExpressionDataStore();
        }

        return ExpressionDataStore.instance;
    }

    public static install(Vue) {
        Vue.prototype.$expressionDataStore = ExpressionDataStore.getInstance();
    }

    private static instance: ExpressionDataStore = null as any;

    constructor() {
        super('expressions', EXPRESSION_SEARCH_TYPES);
    }

    public update(id: string, body: Partial<Expression>, endpointOverride?: string, ignoreCachedStatus: boolean = false) {
        return super.update(id, body, endpointOverride || API_ENDPOINTS[body.type as string], ignoreCachedStatus)
    }

    protected initializeDataFetcher() {
        this.offlineDataFetcher = new ExpressionOfflineDataFetcher(this.sanitizedIdentifer);
    }
}
